/** We might want to customise UI for these codes from OLT */
export const advisoryToolsExpectedCodes = {
	finam: "finam",
	elis: "elis",
	zzj: "meet_rec",
	investmentQuestionnaire: "inv_quest",
	extranets: "extranets",
};
